module.exports = __webpack_public_path__ + "static/img/planet-example.4b7af0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/planet-example.jpg
// module id = n2Iq
// module chunks = 1